/**
 * DIISEA Product Support — sticky nav active state, smooth scroll, video modal
 */
(function () {
  if (window.DiiseaSupport && window.DiiseaSupport.__ready) return;

  var SCROLL_PAD = 8;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function headerOffset() {
    var root = document.documentElement;
    var styles = window.getComputedStyle(root);
    var header = parseFloat(styles.getPropertyValue("--header-height")) || 72;
    var nav = document.querySelector("[data-diisea-support-nav]:not([hidden])");
    var navH = 0;
    if (nav) navH = nav.getBoundingClientRect().height || 56;
    return header + navH + SCROLL_PAD;
  }

  function getNavRoots(scope) {
    var base = scope && scope.querySelectorAll ? scope : document;
    return Array.prototype.slice.call(base.querySelectorAll("[data-diisea-support-nav]"));
  }

  function smoothScrollTo(id) {
    var el = document.getElementById(id);
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({
      top: Math.max(0, top),
      behavior: prefersReducedMotion() ? "auto" : "smooth",
    });
    if (history && history.pushState) {
      history.pushState(null, "", "#" + id);
    }
  }

  function setActiveLink(nav, id) {
    Array.prototype.forEach.call(nav.querySelectorAll("[data-diisea-support-nav-link]"), function (link) {
      var href = link.getAttribute("href") || "";
      var linkId = href.charAt(0) === "#" ? href.slice(1) : "";
      link.classList.toggle("is-active", linkId === id);
    });
  }

  function initNav(nav) {
    if (!nav || nav.dataset.diiseaNavReady === "true") return;
    nav.dataset.diiseaNavReady = "true";

    var links = Array.prototype.slice.call(nav.querySelectorAll("[data-diisea-support-nav-link]"));
    var targets = [];

    links.forEach(function (link) {
      var href = link.getAttribute("href") || "";
      if (href.charAt(0) !== "#") return;
      var id = href.slice(1);
      var target = document.getElementById(id);
      if (!target) {
        var item = link.closest("li");
        if (item) item.setAttribute("hidden", "");
        return;
      }
      targets.push({ id: id, el: target, link: link });

      link.addEventListener("click", function (event) {
        if (!document.getElementById(id)) return;
        event.preventDefault();
        smoothScrollTo(id);
        setActiveLink(nav, id);
      });
    });

    if (!targets.length) {
      nav.setAttribute("hidden", "");
      return;
    }

    if (!("IntersectionObserver" in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        var visible = entries
          .filter(function (entry) {
            return entry.isIntersecting;
          })
          .sort(function (a, b) {
            return b.intersectionRatio - a.intersectionRatio;
          });
        if (!visible.length) return;
        setActiveLink(nav, visible[0].target.id);
      },
      {
        root: null,
        rootMargin: "-30% 0px -55% 0px",
        threshold: [0.1, 0.25, 0.5],
      }
    );

    targets.forEach(function (item) {
      observer.observe(item.el);
    });
  }

  function youtubeId(url) {
    if (!url) return "";
    var m =
      String(url).match(
        /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([A-Za-z0-9_-]{6,})/
      ) || String(url).match(/[?&]v=([A-Za-z0-9_-]{6,})/);
    return m ? m[1] : "";
  }

  function vimeoId(url) {
    if (!url) return "";
    var m = String(url).match(/vimeo\.com\/(?:video\/)?(\d+)/);
    return m ? m[1] : "";
  }

  function initVideoModal(root) {
    if (!root || root.dataset.diiseaVideoReady === "true") return;
    var modal = root.querySelector("[data-diisea-support-modal]");
    var stage = root.querySelector("[data-diisea-support-modal-stage]");
    var closeBtn = root.querySelector("[data-diisea-support-modal-close]");
    if (!modal || !stage) return;

    root.dataset.diiseaVideoReady = "true";

    function closeModal() {
      if (typeof modal.close === "function" && modal.open) modal.close();
      stage.innerHTML = "";
    }

    function openModal(trigger) {
      var source = trigger.getAttribute("data-video-source") || "youtube";
      var url = trigger.getAttribute("data-video-url") || "";
      var shopifySrc = trigger.getAttribute("data-video-shopify") || "";
      stage.innerHTML = "";

      if (source === "shopify" && shopifySrc) {
        var video = document.createElement("video");
        video.src = shopifySrc;
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        stage.appendChild(video);
      } else {
        var yid = youtubeId(url);
        var vid = vimeoId(url);
        var iframe = document.createElement("iframe");
        iframe.setAttribute("allow", "autoplay; encrypted-media; fullscreen");
        iframe.setAttribute("allowfullscreen", "true");
        iframe.title = trigger.getAttribute("data-video-title") || "Video";
        if (yid) {
          iframe.src =
            "https://www.youtube.com/embed/" +
            yid +
            "?autoplay=1&rel=0&modestbranding=1&playsinline=1";
        } else if (vid) {
          iframe.src = "https://player.vimeo.com/video/" + vid + "?autoplay=1";
        } else {
          return;
        }
        stage.appendChild(iframe);
      }

      if (typeof modal.showModal === "function") modal.showModal();
      else modal.setAttribute("open", "");
    }

    root.addEventListener("click", function (event) {
      var trigger = event.target.closest("[data-diisea-support-video-open]");
      if (trigger && root.contains(trigger)) {
        event.preventDefault();
        openModal(trigger);
        return;
      }
      if (event.target.closest("[data-diisea-support-modal-close]")) {
        closeModal();
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener("click", closeModal);
    }

    modal.addEventListener("close", function () {
      stage.innerHTML = "";
    });

    modal.addEventListener("click", function (event) {
      if (event.target === modal) closeModal();
    });
  }

  function initAll(scope) {
    getNavRoots(scope || document).forEach(initNav);
    Array.prototype.forEach.call(
      (scope || document).querySelectorAll("[data-diisea-support-videos]"),
      initVideoModal
    );
  }

  function onReady() {
    initAll(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onReady);
  } else {
    onReady();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target || document);
  });

  window.DiiseaSupport = {
    initAll: initAll,
    __ready: true,
  };
})();
